import React, {Component} from 'react';

class Allergies extends Component {

    render() {

        const allergies = this.props.prescriptionHistory.allergies.map(allergy => (
            <li key={allergy}>{allergy}</li>
        ));
        return (
            <ul>
                {allergies}
            </ul>
        );
    }
}

export default Allergies;
